import  { SketchPicker }  from 'react-color';
import './color-picker.css'
import rgbHex from "rgb-hex";
export function ColorPicker(props) {
    const colorsArray = ['#a61919', '#2c509e', 'green', 'yellow', 'orange', 'pink', 'black', '#fcfcfc']
    return (
      <SketchPicker presetColors ={colorsArray}
        disableAlpha={true} 
        color={props.color ? props.color : 'black'}
        onChange={(color) => color.hex === '#ffffff' ? props.updateColor("#fcfcfc") : props.updateColor("#" + rgbHex(color.rgb.r, color.rgb.g, color.rgb.b, color.rgb.a))}
      />
    );
}